export const title = {
    'en': 'Chart',
    'zh-tw': '圖表'
};

export const showChartTitle = {
    'en': 'chart title [title]',
    'zh-tw': '圖表標題 [title]'
};

export const chartTitle = {
    'en': 'chart title',
    'zh-tw': '圖表標題'
};

export const showAxisTitle = {
    'en': 'axis titles: x axis [X_axis] y axis [Y_axis]',
    'zh-tw': '座標軸標題：X軸[X_axis]Y軸[Y_axis]'
};

export const XAxis = {
    'en': 'x axis title',
    'zh-tw': 'X軸標題'
}

export const YAxis = {
    'en': 'y axis title',
    'zh-tw': 'Y軸標題'
}

export const showChart = {
    'en': 'read data [data] show [chart]',
    'zh-tw': '讀取資料[data]顯示[chart]'
};

export const showChart2 = {
    'en': 'read data [data] from column [n] show [chart]',
    'zh-tw': '從第[n]欄讀取資料[data]顯示[chart]'
};

export const lineChart = {
    'en': 'line chart ',
    'zh-tw': '折線圖'
};

export const barChart = {
    'en': 'bar chart',
    'zh-tw': '長條圖'
};

export const pieChart = {
    'en': 'pie chart',
    'zh-tw': '圓餅圖'
};

export const donutChart = {
    'en': 'donut chart',
    'zh-tw': '環形圖'
};

export const radarChart = {
    'en': 'radar chart',
    'zh-tw': '雷達圖'
};

export const radarChartRange = {
    'en': 'set radar chart range: [min] to [max]',
    'zh-tw': '設定雷達圖數值範圍：[min]至[max]'
};

export const ganttChart = {
    'en': 'gantt chart',
    'zh-tw': '甘特圖'
};

export const setDate = {
    'en': 'Set the dates of the Gantt chart from [start] to [end]',
    'zh-tw': '設定甘特圖的日期從[start]到[end]'
};

export const showGanttChart = {
    'en': 'display gantt chart by reading data[data]',
    'zh-tw': '讀取資料[data]顯示甘特圖'
};